"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CallHistoryController = void 0;
const moment_1 = __importDefault(require("moment"));
const CallHistory_model_1 = require("../../xchelper/models/CallHistory.model");
class CallHistoryController {
    constructor(callHistoryPartyFormatter, $scope, $rootScope, XucUtils, $state, XucPhoneState, CtiProxy, XucCallHistory, $translate, CallHistoryService, callContext, userPreferenceService, XucPhoneEventListener) {
        this.callHistoryPartyFormatter = callHistoryPartyFormatter;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.XucUtils = XucUtils;
        this.$state = $state;
        this.XucPhoneState = XucPhoneState;
        this.CtiProxy = CtiProxy;
        this.XucCallHistory = XucCallHistory;
        this.$translate = $translate;
        this.CallHistoryService = CallHistoryService;
        this.callContext = callContext;
        this.userPreferenceService = userPreferenceService;
        this.XucPhoneEventListener = XucPhoneEventListener;
        this.history = undefined;
        this.historyIndexes = [];
        this.dndPresences = new Map();
        $scope.$on('CallHistoryUpdated', () => {
            this.history = CallHistoryService.MapCallHistoryModelToCallHistoryViewModel(XucCallHistory.getRawCallHistory());
            this.historyIndexes = Object.keys(this.history);
            this.historyIndexes.sort((one, two) => (one > two ? -1 : 1));
            if (!$rootScope.$$phase)
                $scope.$apply();
        });
        this.XucPhoneEventListener.addReleasedHandler(this.$scope, this.onRelease.bind(this));
    }
    getPhoneStateBackColor(call) {
        if (call.dndStatus && call.phoneStatus != CallHistory_model_1.PhoneHintStatus.INDISPONIBLE)
            return "user-status-dnd";
        if (call.videoStatus == CallHistory_model_1.VideoEvents.Busy)
            return "user-videostatus-" + call.videoStatus;
        return "user-status" + call.phoneStatus;
    }
    statusImage(status) {
        const baseUrl = '/assets/images/ucassistant/call_statut_';
        if (status == CallHistory_model_1.CallStatus.Emitted)
            return baseUrl + 'outgoing.svg';
        else if (status == CallHistory_model_1.CallStatus.Answered)
            return baseUrl + 'incoming.svg';
        else if (status == CallHistory_model_1.CallStatus.Missed)
            return baseUrl + 'missed.svg';
        return '';
    }
    stopEventAndDial(event, number) {
        event.stopPropagation();
        this.callContext.normalizeDialOrAttTrans(number);
    }
    stopEventAndCreateContact(event, number, firstname, lastname) {
        event.stopPropagation();
        let contact = {
            "firstname": firstname || '',
            "lastname": lastname || '',
            "number": number || ''
        };
        this.$state.go('interface.personalContact', { "contact": contact });
    }
    formatHistoryDay(date) {
        return (0, moment_1.default)(date).calendar(null, {
            sameDay: '[' + this.$translate.instant('CALENDAR_SAME_DAY') + ']',
            lastDay: '[' + this.$translate.instant('CALENDAR_LAST_DAY') + ']',
            lastWeek: 'dddd [' + this.$translate.instant('CALENDAR_LAST_WEEK') + ']',
            sameElse: 'DD/MM/YYYY'
        });
    }
    ;
    toggleChildrens(item) {
        item.display = !item.display;
        this.userPreferenceService.resetMissedCalls();
    }
    ;
    getCallHistorySubIndexes(index) {
        if (this.history) {
            let indexes = Object.keys(this.history[index]);
            indexes.sort((one, two) => {
                if (this.history) {
                    let temp1 = this.history[index][one][0];
                    let temp2 = this.history[index][two][0];
                    if (temp1.day && temp2.day) {
                        return (temp1.day > temp2.day ? -1 : 1);
                    }
                }
                return -1;
            });
            return indexes;
        }
    }
    getCallHistoryUserStatusClass(call) {
        if (call.initials == "")
            return "externalNumber";
    }
    getDndPresence(call) {
        if (!call.dndStatus) {
            this.dndPresences.delete(call);
            return undefined;
        }
        const cached = this.dndPresences.get(call);
        if (cached)
            return cached;
        const presence = {
            identifier: call.userName || call.firstName + ' ' + call.lastName,
            status: 'DoNotDisturb',
            title: this.$translate.instant('USER_STATUS_DND'),
            icon: 'xivo-user-presence-dnd'
        };
        this.dndPresences.set(call, presence);
        return presence;
    }
    onRelease(event) {
        setTimeout(() => {
            this.XucCallHistory.updateUserCallHistory();
        }, 3000);
    }
}
exports.CallHistoryController = CallHistoryController;
CallHistoryController.$inject = ["callHistoryPartyFormatter", "$scope", "$rootScope", "XucUtils", "$state", "XucPhoneState", "CtiProxy", "XucCallHistory", "$translate", "CallHistoryService", "callContext", "UserPreferenceService", "XucPhoneEventListener"];
